import React, { useState, useEffect } from "react";
import {
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Button,
  Card,
  CardTitle,
  CardBody,
  Spinner,
} from "reactstrap";
import Center from "react-center";
import moment from "moment";
import { urlAPI, getToken, getUser } from "utility/Common";
import Axios from "axios";
import { useDispatch } from "react-redux";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import NumberFormat from "react-number-format";
import Chart from "react-apexcharts";

export default function DashboardSDM() {
  const dispatch = useDispatch();

  const [loadingStats, setLoadingStats] = useState(false);
  const [stats, setStats] = useState({ kontrak: 0, tetap: 0, total: 0 });

  const [showUltah, setShowUltah] = useState(true);
  const [showPendidikan, setShowPendidikan] = useState(true);
  const [showKontrak, setShowKontrak] = useState(true);
  const [showMasaKerja, setShowMasaKerja] = useState(true);
  const [loadingProses, setLoadingProses] = useState(false);
  const [tableUltah, setTableUltah] = useState([]);
  const [tableKontrak, setTableKontrak] = useState([]);
  const [chartState, setChartState] = useState({ series: [], options: {} });
  const [chartMasaKerja, setChartMasaKerja] = useState({
    series: [],
    options: {},
  });

  const fetchStatusKaryawan = () => {
    setLoadingStats(true);
    Axios.get(`${urlAPI}/v1/ReportSdm/statusKaryawan`, {
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        setStats(res.data.result);
        setLoadingStats(false);
      })
      .catch(() => setLoadingStats(false));
  };

  const fetchUltah = () => {
    Axios.get(urlAPI + "/v1/reportSdm/ultah", {
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        setTableUltah(
          res?.data?.result?.rows?.length > 0
            ? res.data.result
            : { rows: [], count: 0 },
        );
      })
      .catch((err) => handleError(err));
  };

  const fetchAkhirKontrak = () => {
    Axios.get(urlAPI + "/v1/reportSdm/akhirkontrak", {
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        setTableKontrak(
          res?.data?.result?.rows?.length > 0
            ? res.data.result
            : { rows: [], count: 0 },
        );
      })
      .catch((err) => handleError(err));
  };

  const fetchGrafikPendidikan = () => {
    Axios.get(urlAPI + "/v1/reportSdm/grafikPendidikan", {
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        const rows = res?.data?.result?.rows || [];
        setChartState({
          series: [
            { name: "PENDIDIKAN", data: rows.map((obj) => obj?.JUMLAH) },
          ],
          options: {
            chart: { type: "bar", toolbar: { show: false } },
            plotOptions: { bar: { borderRadius: 4, horizontal: true } },
            xaxis: { categories: rows.map((obj) => obj?.PENDIDIKAN_AKHIR) },
          },
        });
      })
      .catch((err) => handleError(err));
  };

  const fetchGrafikMasaKerja = () => {
    Axios.get(urlAPI + "/v1/reportSdm/grafikMasaKerja", {
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        const rows = res?.data?.result?.rows || [];
        setChartMasaKerja({
          series: [
            { name: "MASA KERJA", data: rows.map((obj) => obj?.JUMLAH) },
          ],
          options: {
            chart: { type: "area", toolbar: { show: false } },
            xaxis: { categories: rows.map((obj) => obj?.MASAKERJA) },
          },
        });
        setLoadingProses(false);
      })
      .catch((err) => handleError(err));
  };

  const handleError = (err) => {
    setLoadingProses(false);
    if (err.response?.statusText === "Unauthorized") {
      dispatch(handleActionLogout());
    }
  };

  useEffect(() => {
    setLoadingProses(true);
    fetchStatusKaryawan();
    fetchUltah();
    fetchAkhirKontrak();
    fetchGrafikPendidikan();
    fetchGrafikMasaKerja();
  }, []);

  const StatsBox = ({ title, value, icon: Icon, gradient }) => (
    <Card
      className="border-0 shadow-sm"
      style={{
        borderRadius: "15px",
        background: gradient,
        overflow: "hidden",
        position: "relative",
        minHeight: "110px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CardBody className="p-3">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ position: "relative", zIndex: 2 }}
        >
          <div style={{ flex: 1, marginRight: "5px" }}>
            <h6
              className="font-weight-bold mb-1"
              style={{
                color: "rgba(255,255,255,0.9)",
                fontSize: "11px",
                letterSpacing: "0.3px",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
              }}
            >
              {title}
            </h6>
            <h2
              className="text-white font-weight-bold mb-0"
              style={{
                fontSize: "1.4rem",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "baseline",
              }}
            >
              {loadingStats ? <Spinner size="sm" color="light" /> : value}
            </h2>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "45px",
              height: "45px",
              background: "rgba(255,255,255,0.2)",
              backdropFilter: "blur(4px)",
              flexShrink: 0,
            }}
          >
            <Icon size={22} color="#fff" />
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            width: "80px",
            height: "80px",
            background:
              "linear-gradient(rgba(255,255,255,0.15), rgba(255,255,255,0))",
            borderRadius: "50%",
            bottom: "-25px",
            right: "-15px",
            zIndex: 1,
          }}
        />
      </CardBody>
    </Card>
  );

  return (
    <div
      className="p-4"
      style={{ backgroundColor: "#F4F7FB", minHeight: "100vh" }}
    >
      <Card
        className="shadow-lg mb-4"
        style={{
          background: "linear-gradient(135deg, #00b4db 0%, #0083b0 100%)",
          border: "none",
          borderRadius: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "160px",
            height: "160px",
            borderRadius: "50%",
            background: "#fff",
            opacity: 0.15,
            top: "-40px",
            left: "-40px",
          }}
        />
        <CardBody className="p-4" style={{ position: "relative", zIndex: 1 }}>
          <Row className="align-items-center">
            <Col lg="8" md="12" className="text-center text-lg-left">
              <h3
                className="text-white mb-1"
                style={{ fontWeight: "1000", fontSize: "1.5rem" }}
              >
                DASHBOARD SDM
              </h3>
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start">
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    background: "#00ff88",
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "8px",
                    boxShadow: "0 0 10px #00ff88",
                  }}
                ></span>
                <small
                  style={{
                    color: "#fff",
                    fontWeight: "600",
                    fontSize: "12px",
                    opacity: 0.9,
                  }}
                >
                  RINGKASAN STATUS KEPEGAWAIAN REALTIME
                </small>
              </div>
            </Col>
            <Col lg="4" className="d-none d-lg-flex justify-content-end">
              <div
                style={{
                  background: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(10px)",
                  padding: "10px 20px",
                  borderRadius: "15px",
                  border: "1px solid rgba(255,255,255,0.3)",
                }}
              >
                <Icons.Clock size={16} className="text-white mr-2" />
                <small className="text-white font-weight-bold">
                  {new Date().toLocaleDateString("id-ID", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </small>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Row className="mb-2">
        <Col md="4" className="mb-2">
          {" "}
          <StatsBox
            title="KARYAWAN KONTRAK"
            value={`${stats.kontrak} Orang`}
            icon={Icons.FileText}
            gradient="linear-gradient(135deg, #FF9A8B 0%, #FF6A88 100%)"
          />
        </Col>
        <Col md="4" className="mb-2">
          <StatsBox
            title="KARYAWAN TETAP"
            value={`${stats.tetap} Orang`}
            icon={Icons.Shield}
            gradient="linear-gradient(135deg, #21D4FD 0%, #B721FF 100%)"
          />
        </Col>
        <Col md="4" className="mb-2">
          <StatsBox
            title="TOTAL KARYAWAN"
            value={`${stats.total} Orang`}
            icon={Icons.Users}
            gradient="linear-gradient(135deg, #08E1AE 0%, #98EE2C 100%)"
          />
        </Col>
      </Row>

      <Row className="mb-2">
        <Col lg="6" md="6" sm="12" className="mb-4">
          <Card
            className="shadow-sm border-0"
            style={{ borderRadius: "15px", borderTop: "4px solid #4e73df" }}
          >
            <CardBody className="p-3">
              {" "}
              {/* Padding diseragamkan */}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div
                    className="p-2 rounded-circle mr-2"
                    style={{ backgroundColor: "#eef2ff", display: "flex" }}
                  >
                    <Icons.BookOpen size={18} color="#4e73df" />
                  </div>
                  <CardTitle
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "1rem", color: "#222" }}
                  >
                    Pendidikan Akhir
                  </CardTitle>
                </div>
                <Button
                  color="flat-primary"
                  size="sm"
                  onClick={() => setShowPendidikan(!showPendidikan)}
                >
                  {showPendidikan ? (
                    <Icons.ChevronUp size={18} color="#333" />
                  ) : (
                    <Icons.ChevronDown size={18} color="#333" />
                  )}
                </Button>
              </div>
              {showPendidikan && (
                <div className="mt-3">
                  <hr className="my-2" style={{ opacity: 0.1 }} />
                  {loadingProses ? (
                    <Center style={{ height: "300px" }}>
                      <Spinner color="primary" />
                    </Center>
                  ) : (
                    chartState.series[0]?.data?.length > 0 && (
                      <Chart
                        options={{
                          ...chartState.options,
                          colors: ["#4e73df"],
                          xaxis: {
                            ...chartState.options.xaxis,
                            labels: { style: { colors: "#000" } },
                          },
                          yaxis: { labels: { style: { colors: "#000" } } },
                        }}
                        series={chartState.series}
                        type="bar"
                        height={300}
                      />
                    )
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        <Col lg="6" md="6" sm="12" className="mb-4">
          <Card
            className="shadow-sm border-0"
            style={{ borderRadius: "15px", borderTop: "4px solid #1cc88a" }}
          >
            <CardBody className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div
                    className="p-2 rounded-circle mr-2"
                    style={{ backgroundColor: "#e6f9f1", display: "flex" }}
                  >
                    <Icons.TrendingUp size={18} color="#1cc88a" />
                  </div>
                  <CardTitle
                    className="mb-0 font-weight-bold"
                    style={{ fontSize: "1rem", color: "#222" }}
                  >
                    Masa Kerja
                  </CardTitle>
                </div>
                <Button
                  color="flat-success"
                  size="sm"
                  onClick={() => setShowMasaKerja(!showMasaKerja)}
                >
                  {showMasaKerja ? (
                    <Icons.ChevronUp size={18} color="#333" />
                  ) : (
                    <Icons.ChevronDown size={18} color="#333" />
                  )}
                </Button>
              </div>

              {showMasaKerja && (
                <div className="mt-3">
                  <hr className="my-2" style={{ opacity: 0.1 }} />
                  {loadingProses ? (
                    <Center style={{ height: "300px" }}>
                      <Spinner color="success" />
                    </Center>
                  ) : (
                    chartMasaKerja.series[0]?.data?.length > 0 && (
                      <Chart
                        options={{
                          ...chartMasaKerja.options,
                          colors: ["#1cc88a"],
                          xaxis: {
                            ...chartMasaKerja.options.xaxis,
                            labels: { style: { colors: "#000" } },
                          },
                        }}
                        series={chartMasaKerja.series}
                        type="area"
                        height={300}
                      />
                    )
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg="6" md="6" sm="12" className="mb-4">
          <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
            <CardBody className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <Icons.Gift className="mr-2" size={20} color="#e63946" />
                  <CardTitle
                    className="mb-0 font-weight-bold"
                    style={{ color: "#222" }}
                  >
                    Ultah Bulan {moment().format("MMMM")}
                  </CardTitle>
                </div>
                <Button
                  color="flat-danger"
                  size="sm"
                  onClick={() => setShowUltah(!showUltah)}
                >
                  {showUltah ? (
                    <Icons.ChevronUp size={18} color="#333" />
                  ) : (
                    <Icons.ChevronDown size={18} color="#333" />
                  )}
                </Button>
              </div>
              {showUltah && (
                <div className="mt-3">
                  <DataTable
                    noHeader
                    pagination
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: "#f8f9fc",
                          fontWeight: "bold",
                          color: "#000",
                        },
                      },
                      cells: { style: { color: "#000" } },
                    }}
                    data={tableUltah?.rows || []}
                    columns={[
                      {
                        name: "SBU",
                        selector: (row) => row.SBU,
                        width: "70px",
                      },
                      {
                        name: "KARYAWAN",
                        selector: (row) => row.NAMA,
                        cell: (row) => (
                          <div style={{ color: "#000", fontWeight: "500" }}>
                            {row.NAMA}
                            <br />
                            <small style={{ color: "#444" }}>{row.NIK}</small>
                          </div>
                        ),
                      },
                      {
                        name: "TGL LAHIR",
                        selector: (row) =>
                          moment(row.TGLLAHIR).format("DD MMM"),
                        width: "100px",
                      },
                    ]}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </Col>

        <Col lg="6" md="6" sm="12" className="mb-4">
          <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
            <CardBody className="p-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <Icons.AlertCircle
                    className="mr-2"
                    size={20}
                    color="#d97706"
                  />
                  <CardTitle
                    className="mb-0 font-weight-bold"
                    style={{ color: "#222" }}
                  >
                    Kontrak Habis {moment().format("YYYY")}
                  </CardTitle>
                </div>
                <Button
                  color="flat-warning"
                  size="sm"
                  onClick={() => setShowKontrak(!showKontrak)}
                >
                  {showKontrak ? (
                    <Icons.ChevronUp size={18} color="#333" />
                  ) : (
                    <Icons.ChevronDown size={18} color="#333" />
                  )}
                </Button>
              </div>
              {showKontrak && (
                <div className="mt-3">
                  <DataTable
                    noHeader
                    pagination
                    customStyles={{
                      headCells: {
                        style: {
                          backgroundColor: "#fff7ed",
                          fontWeight: "bold",
                          color: "#9a3412",
                        },
                      },
                      cells: { style: { color: "#000" } },
                    }}
                    data={tableKontrak?.rows || []}
                    columns={[
                      {
                        name: "SBU",
                        selector: (row) => row.SBU,
                        width: "70px",
                      },
                      {
                        name: "KARYAWAN",
                        selector: (row) => row.NAMA,
                        cell: (row) => (
                          <div style={{ color: "#000", fontWeight: "500" }}>
                            {row.NAMA}
                            <br />
                            <small style={{ color: "#444" }}>{row.NIK}</small>
                          </div>
                        ),
                      },
                      {
                        name: "AKHIR",
                        selector: (row) =>
                          moment(row.TGLAKHIRKONTRAK).format("DD MMM YY"),
                        width: "110px",
                      },
                    ]}
                  />
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
